import React from 'react'
import { useTranslation } from 'react-i18next'
import { CSpinner } from '@coreui/react-pro'
import { ScryerSpark } from '@scryerlabs/ui'

interface LoadingSpinnerProps {
  fullPage?: boolean
  text?: string
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ fullPage = false, text }) => {
  const { t } = useTranslation()
  const displayText = text || t('common:messages.loading')

  // Full-page waits (sign-in, route/auth, Suspense) get the branded breathing sparkle so the whole
  // stack shares one loading mark; inline content loading keeps the lightweight spinner.
  if (fullPage) {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center gap-3 min-vh-100 bg-body"
        role="status"
        aria-live="polite"
      >
        <ScryerSpark size={48} className="brand-spinner-mark" />
        {displayText && <span className="text-body-secondary small">{displayText}</span>}
      </div>
    )
  }

  return (
    <div className="d-flex justify-content-center p-4">
      <div className="d-flex flex-column align-items-center justify-content-center gap-2">
        <CSpinner color="primary" />
        {displayText && <span className="text-body-secondary">{displayText}</span>}
      </div>
    </div>
  )
}

export default LoadingSpinner
